import React from 'react';
import useBereaMeaStyles from "../styles/berea_mea";
import { Button, Grid, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import { paths } from "../AppRouters";

const CampaignList: React.FC = () => {
    const bereaMeaStyles = useBereaMeaStyles();

    const linkList = [
        { text: 'Kozel Meeet Pre-Untold ( 1 )', path: paths.KozelMeetPreUntold },
        { text: 'Kozel Meeet Untold ( 2 )', path: paths.untoldAdvertising },
        { text: 'Kozel Meeet Untold Challenge 1', path: paths.untoldChallenge.challenge1 },        
        { text: 'Kozel Meeet Untold Challenge 2', path: paths.untoldChallenge.challenge2 },        
        { text: 'Kozel Meeet Untold Challenge 3', path: paths.untoldChallenge.challenge3 },        
        { text: 'Kozel Meeet Untold Challenge Final', path: paths.untoldChallenge.challengeFinal },  
        { text: 'Kozel Meeet Untold Challenge Error', path: paths.untoldChallenge.challengeError },        
        { text: 'Kozel Meeet on trade ( 3 )', path: paths.kozelMeet },        
        // { text: 'Kozel Meeet Untold', path: paths.untoldAdvertising },
        { text: 'Kozel Meeet Boardgames Pub', path: paths.kozelMeetBoardGameAccessPreTribe },
        { text: 'Kozel Meeet Boardgames Congrats', path: paths.kozelMeetBoardGame.game1 },
        { text: 'Kozel Meeet Know Your Tribe Game', path: paths.kozelMeetBoardGameAccess }
    ]

    return (
        <Grid container spacing={2} justifyContent="center">
            {linkList.map((item, index) => (
                <Grid item xs={12} sm={6} md={4} key={index}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <NavLink className={bereaMeaStyles.buttonLink} to={item.path}>
                        <Button className={bereaMeaStyles.button}>{item.text}</Button>
                    </NavLink>
                </Grid>
            ))}
        </Grid>
    );
}

export default CampaignList;